module.exports = __webpack_public_path__ + "static/media/wifi-level-1.522dbce3.svg";